import { Cookies } from 'react-cookie';

import { EncountersOnMapResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getEncountersOnMap = async (floor_slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/encounters/floor/${floor_slug}`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as EncountersOnMapResponse;
};
